import { Suspense } from "react";
import { Routes, Route, BrowserRouter } from "react-router";
import { useMain } from "./hooks/useMain";
import { SiteHeader } from "../../widgets/SiteHeader/SiteHeader";
import PageNotFoundComponent from "../../shared/ui/PageNotFound/PageNotFoundComponent";

export const Routers = () => {
  const { pageLoad, mainRoutes, authRoutes, productRoutes, dataFaq, token } =
    useMain();

  return (
    <BrowserRouter>
      <Suspense fallback={pageLoad}>
        <SiteHeader faqDesc={dataFaq} />
        {!token && (
          <Routes>
            {authRoutes}
            <Route
              path="*"
              key={"key.404NotFound"}
              element={<PageNotFoundComponent />}
            />
          </Routes>
        )}
        {token && (
          <Routes>
            {mainRoutes}
            {productRoutes}
            <Route
              path="*"
              key={"key.404NotFound"}
              element={<PageNotFoundComponent />}
            />
          </Routes>
        )}
      </Suspense>
    </BrowserRouter>
  );
};
